import React, { useState } from "react";
import PropTypes from "prop-types";
import { navigateToBrandPage } from "../brandRadarUtils";

export default function BrandRadarInfoPanel({
  selectedBrand = null,
  similarBrands,
  onNavigateToBrand,
  isMobile = false,
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!selectedBrand) return null;

  const handleViewOnFruits = () => {
    navigateToBrandPage(selectedBrand.id);
  };

  // Mobile: collapsible panel at bottom left
  if (isMobile) {
    return (
      <div
        className={`BrandRadar-info-mobile ${isExpanded ? "is-expanded" : ""}`}
      >
        <button
          type="button"
          className="BrandRadar-info-mobile-toggle"
          onClick={() => setIsExpanded(!isExpanded)}
          aria-expanded={isExpanded}
        >
          <span className="BrandRadar-info-mobile-brand">
            {selectedBrand.id}
          </span>
          <span className="BrandRadar-info-mobile-arrow">
            {isExpanded ? "▼" : "▲"}
          </span>
        </button>
        {isExpanded && (
          <div className="BrandRadar-info-mobile-content">
            <button
              type="button"
              className="BrandRadar-info-link"
              onClick={handleViewOnFruits}
            >
              View on Fruits
              <svg
                viewBox="0 0 12 12"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path d="M4.5 1.5h6v6M10.5 1.5L1.5 10.5" />
              </svg>
            </button>
            <div className="BrandRadar-info-label">TOP 10 SIMILAR</div>
            <div className="BrandRadar-info-tags">
              {similarBrands.map((name) => (
                <button
                  type="button"
                  key={name}
                  className="BrandRadar-info-tag"
                  onClick={() => {
                    onNavigateToBrand(name);
                    setIsExpanded(false);
                  }}
                >
                  {name}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }

  // Desktop: standard panel
  return (
    <div className="BrandRadar-info">
      <div className="BrandRadar-info-panel is-visible">
        <h2 className="BrandRadar-info-name">{selectedBrand.id}</h2>
        <button
          type="button"
          className="BrandRadar-info-link"
          onClick={handleViewOnFruits}
        >
          View on Fruits
          <svg
            viewBox="0 0 12 12"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <path d="M4.5 1.5h6v6M10.5 1.5L1.5 10.5" />
          </svg>
        </button>
        <div className="BrandRadar-info-label">TOP 10 SIMILAR</div>
        <div className="BrandRadar-info-tags">
          {similarBrands.map((name) => (
            <button
              type="button"
              key={name}
              className="BrandRadar-info-tag"
              onClick={() => onNavigateToBrand(name)}
            >
              {name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

BrandRadarInfoPanel.propTypes = {
  selectedBrand: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  similarBrands: PropTypes.arrayOf(PropTypes.string).isRequired,
  onNavigateToBrand: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};
